<template>
  <div>
    <v-text-field outlined prepend-inner-icon="mdi-magnify" color="black" hide-details v-model="search" class="my-6">
      <template v-slot:label>{{ $t("collecte.rechercher") }}</template>
    </v-text-field>
    <v-row>
      <v-col cols="12" md="6" class="py-0" v-for="(objectif, index) in objectifsFiltres" :key="objectif.identifiant">
        <v-sheet outlined class="mx-auto pa-4 pa-md-8 my-12 grey lighten-4">
          <objectif-card :objectif="objectif" hideMessages></objectif-card>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ObjectifCard from "./ObjectifCard"
export default {
  name: "ObjectifGrid",
  components: { ObjectifCard },
  data() {
    return {
      search: ""
    }
  },
  props: {
    listeObjectifs: Array,
    identifiantCollecte: String,
    lang: String
  },
  computed: {
    objectifsFiltres() {
      return this.listeObjectifs?.filter((o) => o.titre.toLowerCase().includes(this.search.toLowerCase())) ?? []
    }
  }
}
</script>

<style scoped>
</style>